import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="route-map-reports--filters"
export default class extends Controller {
  static targets = [
    "customDateRangeFields",
    "fieldSelect",
    "lotSelect",
    "dateRangeWarning",
    "lotSelectError",
  ];
  static values = {
    allCustomFields: Object,
    maxDateRangeDays: { type: Number, default: 365 },
  };

  connect() {
    this.toggleCustomDateRangeFields();

    // Initialize field select if form is already selected
    const formSelect = document.getElementById(
      "q_sanitation_route_sanitation_form_id_eq"
    );
    if (formSelect && formSelect.value) {
      this.updateCustomFields(formSelect.value);
    }

    // Add form submit handler to validate lot selection
    const form = this.element.closest("form") || this.element.querySelector("form");
    if (form) {
      form.addEventListener("submit", this.validateLotSelection.bind(this));
    }
  }

  validateLotSelection(event) {
    if (!this.hasLotSelectTarget) return;

    const selectedLots = Array.from(this.lotSelectTarget.selectedOptions).filter(
      (option) => option.value !== ""
    );

    if (selectedLots.length === 0) {
      event.preventDefault();
      if (this.hasLotSelectErrorTarget) {
        this.lotSelectErrorTarget.textContent = this.lotSelectErrorTarget.dataset.message || "Please select at least one lot";
        this.lotSelectErrorTarget.classList.remove("hidden");
      }
      // Focus on the lot select
      this.lotSelectTarget.focus();
      return false;
    } else {
      // Clear error if lots are selected
      if (this.hasLotSelectErrorTarget) {
        this.lotSelectErrorTarget.textContent = "";
        this.lotSelectErrorTarget.classList.add("hidden");
      }
    }
  }

  // Clear error when lots are selected
  lotSelectChanged() {
    if (this.hasLotSelectTarget && this.hasLotSelectErrorTarget) {
      const selectedLots = Array.from(this.lotSelectTarget.selectedOptions).filter(
        (option) => option.value !== ""
      );
      if (selectedLots.length > 0) {
        this.lotSelectErrorTarget.textContent = "";
        this.lotSelectErrorTarget.classList.add("hidden");
      }
    }
  }

  toggleCustomDateRangeFields() {
    const dateRangeSelect = document.getElementById("q_date_range");
    if (!dateRangeSelect) return;

    const isCustom = dateRangeSelect.value === "custom";
    const fromDate = document.getElementById("q_created_at_gteq");
    const toDate = document.getElementById("q_created_at_lteq");

    if (!isCustom) {
      // Clear date range fields if not custom
      if (fromDate) fromDate.value = "";
      if (toDate) toDate.value = "";

      // Remove required attribute
      if (fromDate) fromDate.required = false;
      if (toDate) toDate.required = false;
    } else {
      if (fromDate) fromDate.required = true;
      if (toDate) toDate.required = true;
    }

    if (this.hasCustomDateRangeFieldsTarget) {
      this.customDateRangeFieldsTarget.classList.toggle("hidden", !isCustom);
    }

    // Clear warning when switching away from custom
    if (!isCustom && this.hasDateRangeWarningTarget) {
      this.dateRangeWarningTarget.textContent = "";
    }
  }

  validateDateRange() {
    const fromDate = document.getElementById("q_created_at_gteq");
    const toDate = document.getElementById("q_created_at_lteq");

    if (!fromDate || !toDate || !fromDate.value || !toDate.value) {
      if (this.hasDateRangeWarningTarget) {
        this.dateRangeWarningTarget.textContent = "";
      }
      return;
    }

    const start = new Date(fromDate.value);
    const end = new Date(toDate.value);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (this.hasDateRangeWarningTarget) {
      if (diffDays > this.maxDateRangeDaysValue) {
        this.dateRangeWarningTarget.textContent = `El rango máximo es de ${this.maxDateRangeDaysValue} días. Rango actual: ${diffDays} días.`;
      } else if (start > end) {
        this.dateRangeWarningTarget.textContent =
          "La fecha de inicio debe ser anterior a la fecha de fin.";
      } else {
        this.dateRangeWarningTarget.textContent = "";
      }
    }
  }

  // Handle form selection change
  sanitationFormChanged(event) {
    const formId = event.target.value;
    this.updateCustomFields(formId);
  }

  // Update custom fields based on selected form
  updateCustomFields(formId) {
    if (!this.hasFieldSelectTarget) return;

    // Get the currently selected fields from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const selectedFieldIds = urlParams.getAll("selected_fields[]");

    // Clear current selection
    this.fieldSelectTarget.innerHTML = "";

    // Add blank option for "all fields"
    const blankOption = document.createElement("option");
    blankOption.value = "";
    blankOption.textContent = "Todos los campos";
    this.fieldSelectTarget.appendChild(blankOption);

    if (formId && this.allCustomFieldsValue) {
      // Get fields for this form
      const formFields = this.allCustomFieldsValue[formId] || [];

      // Add field options
      formFields.forEach((field) => {
        const option = document.createElement("option");
        option.value = field.id;
        option.textContent = field.name;

        // Set selected if this was the previously selected field
        if (selectedFieldIds.includes(field.id.toString())) {
          option.selected = true;
        }

        this.fieldSelectTarget.appendChild(option);
      });

      // Enable the field select
      this.fieldSelectTarget.disabled = false;
    } else {
      // If no form selected, disable the field select
      this.fieldSelectTarget.disabled = true;
    }
  }
}

